module.exports = __webpack_public_path__ + "img/glitter-green.deeb3562.png";